import type { Experiment } from "./_schema";

/**
 * MM-0102: hide the intro block on screen one of every Boost quiz.
 *
 * The variant arm renders no headline, no lede, no testimonial card and no
 * progress bar on screen one -- the question and its options are the whole
 * screen. Authored on each quiz as `meta.introVariantTag: "control"` and
 * resolved by `introVisible()` in web/src/state/visibleQuestions.ts.
 *
 * ONE CONSTANT, THIRTEEN CALL SITES, ON PURPOSE. Thirteen hand-copied UUIDs is
 * thirteen chances to mistype one, and a wrong id resolves NOTHING -- which is
 * rule 24's dead-id blackout on that one quiz (the resolver burns its full
 * 3000ms ceiling on every session while `analytics` stays null, so anyone
 * leaving inside it emits no `started` and no `question_viewed` at all). It
 * would read as "that quiz just converts worse", which is the one conclusion
 * this test cannot afford to invite.
 *
 * PAUSED 2026-09-23: the operator has not launched the test. Public quiz-v6
 * visits returned no group and paid the full 3000ms wait. Keep the definition
 * and intro tags ready, but leave every quiz's experiment unset until launch.
 *
 * WHEN THE TEST STOPS, DELETE THIS FILE AND ITS 13 REFERENCES IN THE SAME
 * WEEK. A stopped test is indistinguishable from a dead id, and rule 24
 * records that this has already been paid twice -- MM-0064's wrong id, then
 * MM-0093's late disarm.
 */
export const MM_0102_DEFINITION: Experiment = {
  intelligemsTestId: "1e2b60e3-1d6b-4a9a-842b-68ea62d782c7",
  name: "MM-0102 Show Only the Question and Options on the Quiz Start Screen",
};

// Restore MM_0102_DEFINITION only after launch and public assignment are verified.
// Update experiment-arming tests and the two-arm regression baselines together.
export const MM_0102: Experiment | undefined = undefined;
